<template>
  <div :class="flex + ' ' + size">
    <slot name="label">
      <label :for="props.name" class="my-auto" :class="props.classes">{{ label }}</label>
    </slot>
    <slot :value="value">
      <InputNumber
        :input-id="props.name"
        class="h-10"
        :class="numberClass"
        :input-class="inputClass"
        :name="props.name"
        v-model="value"
        :mode="props.mode"
        :showButtons="props.showButtons"
        increment-button-class="py-0!"
        decrement-button-class="py-0!"
        :min="props.min"
        :max="props.max"
        :currency="currency"
        :allowEmpty="false"
        :disabled
      />
    </slot>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

//TODO: replace a bunch of the input numbers and labels with this

interface Props {
  name: string;
  label: string;
  size?: string;
  classes?: string;
  disabled?: boolean;
  showButtons?: boolean;
  min?: number;
  max?: number;
  mode?: "decimal" | "currency";
  stacked?: boolean;
  numberClass?: string;
  inputClass?: string;
  value?: number;
}
const props = withDefaults(defineProps<Props>(), {
  size: "w-full",
  classes: "font-bold",
  disabled: false,
  showButtons: false,
  mode: "decimal",
  stacked: true,
  numberClass: "",
  inputClass: "",
});

const currency = computed<string | undefined>(() => (props.mode === "currency" ? "USD" : undefined));

const value = defineModel<number>({ required: true });

const flex = props.stacked ? "flex flex-col" : "flex flex-row";
</script>
